import React from 'react';

import Header from './Header';
import Sidebar from './Sidebar';
import BodyComponent from './BodyComponent';
import styles from './Dashboard.module.scss';
import useUser from '../../../shared/hooks/useUser';

const Dashboard: React.FC = () => {
  const [user] = useUser();

  return (
    <div>
      {typeof user !== 'undefined' && (
        <div className={styles.gridContainer}>
          <header className={styles.topNav}>
            <Header user={user} />
          </header>
          <div className={styles.sideNav}>
            <Sidebar />
          </div>
          <div className={styles.main}>
            <BodyComponent user={user} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
